module.exports = __webpack_public_path__ + "assets/img/yyindex-1.e121fbf4.png";